<template>
  <div>
    <van-nav-bar
      title="生产单管理"
      left-arrow
      @click-left="$router.back()"
    />
    <van-sticky :offset-top="0">
      <van-row>
        <van-col :span="24">
          <base-select v-model="queryCondition.workshop_id" :options="workshopList" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <base-datetime v-model="queryCondition.begin_delivery_time" label="送货起始日期" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <base-datetime v-model="queryCondition.end_delivery_time" label="送货截止日期" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <base-input v-model="queryCondition.code" label="单号" />
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24">
          <van-field name="checkboxGroup" label="状态">
            <template #input>
              <van-checkbox-group v-model="queryCondition.statusList" direction="horizontal">
                <van-checkbox v-for="status in CONST.PRODUCE_STATUS" :key="status.id"
                              :name="status.id" shape="square">
                  {{ status.name }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="24" style="text-align: right; padding-right: 2px;">
          <base-button type="warning" @click="handleResetQC()">重置</base-button>
          <base-button @click="query">查询</base-button>
        </van-col>
      </van-row>
    </van-sticky>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell v-for="row in data" :key="row.id">
            <van-panel :title="row.code" :desc="'送货时间：' + row.delivery_time"
                       :status="CONST.PRODUCE_STATUS.find(status => status.id === row.status).name">
              <div>
                <van-row>
                  <van-col :span="12">
                    订货人：{{ row.orderer }}
                  </van-col>
                  <van-col :span="12">
                    订货人电话：{{ row.orderer_phone }}
                  </van-col>
                </van-row>
              </div>
              <div slot="footer">
                <van-row>
                  <van-col :span="6">
                    <span style="font-weight: bold;">￥{{ row.total_amount | toThousandFilter }}</span>
                  </van-col>
                  <van-col :span="18" style="text-align: right;">
                    <base-button type="info" @click="handleStatus(row, 2, '开始制作')">开始</base-button>
                    <base-button type="primary" @click="handleStatus(row, 3, '制作完成')">完成</base-button>
                    <base-button type="danger" @click="handleStatus(row, 4, '取消制作')">取消</base-button>
                    <base-button type="primary" @click="handleQualityStatus(row, 2, '合格')">合格</base-button>
                    <base-button type="warning" @click="handleDetails(row)">详情</base-button>
                  </van-col>
                </van-row>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-popup
        v-model="showForm"
        closeable
        close-icon="close"
        position="center"
        :style="{ width: '90%' }"
      >
        <van-col :span="24" style="text-align: center; margin-top: 20px;">
          订单信息
        </van-col>
        <van-col v-if="selectedRow" :span="24">
          <base-input v-model="selectedRow.order_date" label="订单时间" readonly />
          <base-input v-model="selectedRow.code" label="订单号" readonly />
          <base-input v-model="selectedRow.source_name" label="订单来源" readonly />
          <base-input v-model="selectedRow.status_name" label="状态" readonly />
          <base-input v-model="selectedRow.orderer" label="订货人" readonly />
          <van-col v-for="(detail, index) in selectedRow.details" :key="detail.key" :span="24">
            <van-card :num="detail.count" :price="detail.price" :desc="detail.goods_name" :title="'产品' + (index + 1)"
                      thumb="https://img.yzcdn.cn/vant/ipad.jpeg">
              <div slot="tags">
                <van-tag v-if="detail.type_name" plain type="danger">{{ detail.type_name }}</van-tag>
                <van-tag v-if="detail.specs" plain type="primary">{{ detail.specs }}</van-tag>
              </div>
            </van-card>
            <van-col :span="10">
              <base-input-number v-model="detail.discount" label="折扣" readonly />
            </van-col>
            <van-col :span="14">
              <base-input-number v-model="detail.amount" label="小计" readonly />
            </van-col>
            <van-col :span="24">
              <base-textarea v-model="detail.remark" label="特殊要求" readonly />
            </van-col>
          </van-col>
          <base-input-number v-model="selectedRow.total_amount" label="合计金额" readonly />
          <van-row v-for="(pay, index) in selectedRow.pay_details" :key="pay.key">
            <van-col :span="24">
              <base-input v-model="pay.pay_agreed_name" :label="'支付约定' + (index + 1)" readonly />
            </van-col>
            <van-col :span="24">
              <base-input v-model="pay.pay_type_name" :label="'支付方式' + (index + 1)" readonly />
            </van-col>
            <van-col :span="24">
              <base-input-number v-model="pay.amount" label="金额" readonly />
            </van-col>
          </van-row>
          <base-textarea v-model="selectedRow.remark" label="备注" readonly />
          <base-input v-model="selectedRow.delivery_time" label="送货时间" readonly />
          <base-input v-model="selectedRow.create_name" label="创建人" readonly />
        </van-col>
      </van-popup>
    </van-col>

    <init :init-states="initStates" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Init from '@/components/base/init'
import { getProduceOrderList, modifyStatusProduceOrder,
  qualityStatusOfProduceOrder } from '@/api/produce/order'
import { getWorkshopList } from '@/api/settings/workshop'
export default {
  name: 'ProduceOrderManage',
  components: { Init },
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,
      showSearchList: false,
      showForm: false,

      selectedRow: null,
      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '生产单').id,

        workshop_id: null,
        code: '',
        statuses: '',
        statusList: [],
        begin_delivery_time: this.Utils.df(null, '{y}-{m}-{d} 00:00:00'),
        end_delivery_time: this.Utils.df(null, '{y}-{m}-{d} 23:59:59')
      },
      workshopList: [],
      initStates: [{
        key: 'goods/init'
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.queryWorkshopList().then(() => {
      this.query()
    })
  },
  methods: {
    handleDetails(row) {
      this.selectedRow = row
      this.selectedRow.status_name = this.CONST.PRODUCE_STATUS.find(status => status.id === row.status).name
      this.showForm = true
    },
    queryWorkshopList() {
      return new Promise((resolve) => {
        getWorkshopList({
          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.MAX_ROWS,
          sort: 'id',
          order: 'asc'
        }).then(resp => {
          this.workshopList = resp.rows || []
          if (this.workshopList.length > 0) {
            this.queryCondition.workshop_id = this.workshopList[0].id
          }
          resolve()
        })
      })
    },
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      this.queryCondition.statuses = this.queryCondition.statusList.join(',')
      getProduceOrderList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.loading = false
        this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    handleResetQC() {
      this.Utils.resetValue(this.queryCondition)
      this.queryCondition.begin_delivery_time = this.Utils.df(null, '{y}-{m}-{d} 00:00:00')
      this.queryCondition.end_delivery_time = this.Utils.df(null, '{y}-{m}-{d} 23:59:59')
      if (this.workshopList.length > 0) {
        this.queryCondition.workshop_id = this.workshopList[0].id
      }
    },
    handleStatus(row, status, msg) {
      const tip = `确定此单 <label class="${msg === '取消制作' ? 'err-msg' : 'tip-msg'}">${row.code} ${msg}</label> 吗？`
      this.confirm(tip).then(() => {
        modifyStatusProduceOrder({
          ids: row.id.toString(),
          status: status
        }).then(resp => {
          this.success(resp.msg)
          this.query()
        })
      })
    },
    handleQualityStatus(row, status, msg) {
      const tip = `确定此单 <label class="tip-msg">${row.code} ${msg}</label> 吗？`
      this.confirm(tip).then().then(() => {
        qualityStatusOfProduceOrder({
          ids: row.id.toString(),
          quality_status: status
        }).then(resp => {
          this.success(resp.msg)
          this.query()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/produce/order-manage.vue